export default "__VITE_ASSET__e08f5743__"